module.exports = __webpack_public_path__ + "img/Portafolio MiloHealth_2.b6bc33df.png";